import React, { useState } from 'react';
import { Eye, Loader, Mail } from 'lucide-react';
import { useAuth } from './AuthContext';

export default function Login() {
  const { signIn, magicLinkRequired } = useAuth();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [awaitLink, setAwaitLink] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    setError('');
    const { error, awaitLink: needsClick } = await signIn(email.trim());
    setLoading(false);
    if (error) { setError(error.message); return; }
    if (needsClick) setAwaitLink(true);
    // else: セッションが更新されて自動的にAppへ遷移
  };

  if (awaitLink) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-sm text-center">
          <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Mail className="w-8 h-8 text-indigo-600" />
          </div>
          <h2 className="text-xl font-bold text-slate-800 mb-2">メールを確認してください</h2>
          <p className="text-slate-500 text-sm">
            <span className="font-medium text-slate-700">{email}</span> に<br />
            ログインリンクを送信しました。<br />
            メール内のリンクをクリックしてください。
          </p>
          <button
            onClick={() => { setAwaitLink(false); setEmail(''); }}
            className="mt-6 text-sm text-indigo-600 hover:underline"
          >
            別のメールアドレスを使う
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4">
            <Eye className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-slate-800">ProductMatcher</h1>
          <p className="text-slate-500 text-sm mt-1">
            {magicLinkRequired
              ? 'メールアドレスを入力してログインリンクを受け取る'
              : 'メールアドレスを入力して開始'}
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              メールアドレス
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="example@company.com"
              required
              autoFocus
              className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            />
          </div>

          {error && (
            <p className="text-sm text-red-600 bg-red-50 p-2 rounded">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading || !email.trim()}
            className="w-full py-3 bg-indigo-600 hover:bg-indigo-700 disabled:bg-slate-300 text-white font-bold rounded-lg flex items-center justify-center gap-2 transition-colors"
          >
            {loading ? (
              <><Loader className="w-4 h-4 animate-spin" /> 処理中...</>
            ) : magicLinkRequired ? (
              'ログインリンクを送信'
            ) : (
              '使用開始'
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
